import { useLocation, useNavigate } from 'react-router-dom';

import { LogoIcon } from 'assets';

import ResetPasswordForm from 'entities/Auth/components/ResetPasswordForm';
import { resetPassword } from 'entities/Auth/sdk';

import Text from 'components/Text';

import { URLS } from 'config/urls';

const ResetPasswordPage = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const token = searchParams.get('token') || '';

  const handleSave = (data: {
    password: string;
    confirm_password: string;
    token: string;
  }) => {
    return resetPassword(data).then(() => {
      navigate(URLS.LOGIN);
    });
  };

  return (
    <>
      <div className="flex h-screen w-screen items-center">
        <div className="flex h-fit w-full flex-col items-center">
          <LogoIcon />
          <div className="m-0 mt-[-40px] flex w-[300px] flex-col gap-[54px]">
            <Text
              classes={{
                root: 'font-medium text-[32px] leading-[48px] text-center'
              }}
            >
              Set a password in order to activate your account
            </Text>
            <ResetPasswordForm onSave={handleSave} token={token} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordPage;
